export { Heading } from "./Heading";
export { SubHeading } from "./SubHeading";
export { UpperHeading } from "./UpperHeading";
export { Paragraph } from "./Paragraph";
export { CardHeading } from "./CardHeading";
export { CardText } from "./CardText";
export { SmallText } from "./SmallText";
